import { createFileRoute } from '@tanstack/react-router';

import { ensureMediaQueryData } from '@/api/media';
import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { requireMediaRead } from '@/features/permissions/route-permissions';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media'
)({
  // beforeLoad runs before any child loader, so child routes never request media without access
  beforeLoad: ({ context: { estate }, params }) => {
    requireMediaRead(estate.metadata?.permissions, {
      type: 'estate',
      estateId: params.estateId,
    });
  },
  loader: ensureMediaQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="media" /> },
});
